import { useMutation } from 'react-query';

import type { CompleteRelativityOAuthRequestDto } from '../../../../backend/src/auth/oauth/dto/complete-relativity-oauth-request.dto';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

// Exchanges the code from the OAuth popup for tokens; the backend only accepts it from the user who started the flow.
const useCompleteRelativityOAuth = () => {
  const { getFetchConfig } = useGetFetchConfig();

  return useMutation<{ success: boolean }, Error, CompleteRelativityOAuthRequestDto>(async ({ state, code }) => {
    const response = await fetch(
      `${APIBaseChronos}/oauth/relativity/complete`,
      getFetchConfig({ method: FetchMethod.POST, data: { state, code } }),
    );

    if (!response.ok) {
      const body = await response.json().catch(() => null);
      throw new Error(body?.message ?? `Failed to complete Relativity sign-in (${response.status})`);
    }

    return response.json();
  });
};

export default useCompleteRelativityOAuth;
